import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import styles from 'assets/jss/Report/ReportStyle';
import {Skeleton} from '@mui/material';
const useStyles = makeStyles(styles);

const Tab = ({activeTab, reviewClicked, logbookClicked, showSkeleton}) => {
  const classes = useStyles();

  const reportStyle = `${activeTab === 1 && classes.activeReportTabStyle} ${
    classes.tabContainerStyle
  }`;
  const logbookStyle = `${activeTab === 2 && classes.activeLogbookTabStyle} ${
    classes.tabContainerStyle
  }`;

  const LoadingText = () => (
    <Skeleton
      variant='rectangular'
      width={100}
      height={25}
      sx={{borderRadius: '98px'}}
    />
  );

  return (
    <Grid container mt='50px'>
      <Grid className={reportStyle} onClick={reviewClicked} item xs={6}>
        {showSkeleton ? <LoadingText /> : 'REPORT'}
      </Grid>
      <Grid className={logbookStyle} onClick={logbookClicked} item xs={6}>
        {showSkeleton ? <LoadingText /> : '  LOG BOOK'}
      </Grid>
    </Grid>
  );
};

export default Tab;
